import { t } from "../../i18n";
import { backendApiCoverageStyles as styles } from "./backend-api-coverage-styles";
import type {
  ApiCoverageStrength,
  BackendApiTestCase,
} from "./backend-api-coverage-types";

interface TestCaseDetailsProps {
  testCase: BackendApiTestCase;
  strength?: ApiCoverageStrength;
}

export function TestCaseDetails({
  testCase,
  strength,
}: TestCaseDetailsProps): React.JSX.Element {
  return (
    <details style={styles.testDetails}>
      <summary style={styles.testSummary}>
        {strength ? `${t(`api_coverage.strength.${strength}`)} · ` : ""}
        {testCase.method}: {testCase.title}
      </summary>
      <p style={styles.testLogic}>{testCase.logic}</p>
      <span style={styles.meta}>
        {t("api_coverage.linked_endpoint_count", {
          count: testCase.linked_endpoint_ids.length,
        })}
      </span>
    </details>
  );
}
